import {Component, OnChanges, Output, EventEmitter, Input, OnInit, ElementRef} from '@angular/core';

import { CDSNode } from '../../services/capd.model';
import { OrgService } from '../../services/org.service';
import {Rule} from '../../services/capd.model';
import {document} from 'ngx-bootstrap/utils';

@Component({
    selector: 'company-assign-content',
    templateUrl: './company-assign-content.component.html',
    inputs: ['org']
})

/**
 * This class defines the modal used to assign content to a company.
 */
export class CompanyAssignContentComponent implements OnInit, OnChanges {
    @Output() update: EventEmitter<any> = new EventEmitter<any>();
    @Input() org: CDSNode;
    // this is a dummy value used to set off the "ngOnChanges" function after rules are deleted
    @Input() dummyRules;
    ruleList: Rule[];
    toAdd: Rule[] = [];

    constructor(private _service: OrgService,
                private _el: ElementRef) { }

    /**
     * On initialization, get the list of unassigned org content.
     *
     * @async
     * @func ngOnInit
     */
    ngOnInit() {
        this._service.getUnassignedOrgContent(this.org.rootId)
            .then((rules: Rule[]) => {
                this.ruleList = rules;
            });
    }

    /**
     * On changes, refresh the list of unassigned org content.
     *
     * @async
     * @func ngOnChanges
     */
    ngOnChanges() {
        this._service.getUnassignedOrgContent(this.org.rootId)
            .then((rules: Rule[]) => this.ruleList = rules);
    }

    /**
     * Change the currently selected rule
     *
     * @func updateChecked
     * @param {any} option - a rule trigger code to add to the org.
     */
    updateChecked(option) {
        if (this.toAdd.length > 0 && this.toAdd.indexOf(option) >= 0) {
            const location = this.toAdd.indexOf(option);
            this.toAdd.splice(location, 1);
        } else {
            this.toAdd.push(option);
        }

    }

    /**
     * Confirms the assignment of a rule to an org, and updates the tables accordingly.
     *
     * @async
     * @func onSubmit
     */
    onSubmit() {
        this._service.addOrgRules(this.org.rootId, this.toAdd).then(() => {
            this.update.emit();
            this.ngOnChanges();
        });
        this.onCancel();
    }

    /**
     * When you cancel to dismiss the modal, clear the current rule to add.
     *
     * @func onCancel
     */
    onCancel() {
        this.toAdd = [];
        document.getElementById('rulesearchbar').value = '';
        this.searchRules();
        $(this._el.nativeElement).find('#modal-assign-content').hide();
    }

    searchRules() {
        const input = document.getElementById('rulesearchbar').value.toLowerCase();
        let found = false;

        this.ruleList.forEach(r => {
            if (!r.triggerCode.toLowerCase().includes(input) && !r.triggerName.toLowerCase().includes(input)) {
                document.getElementById('item' + r.triggerCode).style.display = "none";
            } else {
                document.getElementById('item' + r.triggerCode).style.display = "list-item";
                found = true;
            }
        });
    }
}
